import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/Home.vue'

const login = () => import('../components/Login.vue')
const index = () => import('../components/index.vue')
const indextable = () => import('../components/indextable.vue')
const creative = () => import('../components/creative.vue')
const setting = () => import('../components/setting.vue')
const flowSetting = () => import('../components/flowSetting.vue')
const addFlow = () => import('../components/addFlow.vue')
const freencysetting = () => import('../components/freencysetting.vue')
const commonsetting = () => import('../components/commonsetting.vue')
const mediaStrategy = () => import('../components/mediaStrategy.vue')
const dspStrategy = () => import('../components/dspStrategy.vue')
const dspStrategyDetail = () => import('../components/dspStrategyDetail.vue')
const dspDealDesk = () => import('../components/dspDealDesk.vue')
const dspDealCreate = () => import('../components/dspDealCreate.vue')
const dspDealEdit = () => import('../components/dspDealEdit.vue')
const dealMapping = () => import('../components/dealMapping.vue')
const adxSetting = () => import('../components/adxSetting.vue')
const wyCreative = () => import('../components/wyCreative.vue')
const wyAddCreative = () => import('../components/wyAddCreative.vue')
const iQiYiad = () => import('../components/iQiYiad.vue')
const iQiYiCreative = () => import('../components/iQiYiCreative.vue')
const mgCreative = () => import('../components/mgCreative.vue')
const mgCreative2 = () => import('../components/mgCreative2.vue')
const mgCreative3 = () => import('../components/mgCreative3.vue')

const commAdUser = () => import('../components/commAdUser.vue')
const wbAdvertisers = () => import('../components/wbAdvertisers.vue')
const sohuAdvertisers = () => import('../components/sohuAdvertisers.vue')
const sohuCreative = () => import('../components/sohuCreative.vue')
const xiaomiCreative = () => import('../components/xiaomiCreative.vue')

const wbCreative = () => import('../components/wbCreative.vue')
const MeituCreative = () => import('../components/MeituCreative.vue')
const idxAdvertiser = () => import('../components/idxAdvertiser.vue')
const idxIdeas = () => import('../components/idxIdeas.vue')
const msAdvertiser = () => import('../components/msAdvertiser.vue')
const msIdeas = () => import('../components/msIdeas.vue')
const bdIdeas = () => import('../components/bdIdeas.vue')
const zhIdeas = () => import('../components/zhIdeas.vue')
const ottUpload = () => import('../components/ottUpload')
const tcIdeas = () => import('../components/tcIdeas')

// 腾讯ADX模块的路由 - 即WAY
const tencentAdvertiser = () => import('../components/tencentAdvertiser') // 腾讯广告主
const tencentQualification = () => import('../components/tencentQualification') // 腾讯营销资产
const tencentIdeas = () => import('../components/tencentIdeas') // 腾讯创意

const zfbIdeas = () => import('../components/zfbIdeas')
const uploadImg = () => import('../components/uploadImg')

const YouKuAdvertiser = () => import('../components/YouKuAdvertiser') // youku广告主
const YouKuCreative = () => import('../components/YouKuCreative') // youku创意
const YouKuCreativeAdd = () => import('../components/YouKuCreativeAdd') // youku创意

// VIOOH
const VIOOHIdeas = () => import('../components/VIOOHIdeas') // VIOOH创意
const leboCreative = () => import('../components/leboCreative') // 乐播创意
const miguCreative = () => import('../components/miguCreative') // 咪咕创意

// 海直创意
const HaizhiCreative = () => import('../components/HaizhiCreative') 

// oppo创意
const oppoCreative = () => import('../components/oppoCreative')
// b站创意
const bilibiliCreative = () => import('../components/bilibiliCreative') // b站创意
// 银河ott创意
const yinheCreative = () => import('../components/yinheCreative')

// 搜狐新闻广告主
const sohuNewsAdvertiser = () => import('../components/sohuNewsAdvertiser')
// 搜狐新闻创意
const sohuNewsCreative = () => import('../components/sohuNewsCreative')

// 投放管理模块
const delivery = () => import('../components/delivery')
const deliveryProject = () => import('../components/deliveryProject')
const deliveryProjectAdd = () => import('../components/deliveryProjectAdd')
const deliveryProjectAnalysis = () => import('../components/deliveryProjectAnalysis')
const deliveryPlan = () => import('../components/deliveryPlan')

// 数据报告模块
const report = () => import('../components/report')
const reportProject = () => import('../components/reportProject')
const sspslot = () => import('../components/sspslot')
const sspreport2 = () => import('../components/sspreport2')
const dealrealtime = () => import('../components/dealrealtime')
const realtime = () => import('../components/realtime')
const middle = () => import('../components/middle')
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/middle',
            component: middle
        },
        {
            path: '/uploadImg',
            component: uploadImg
        },
        {
            path: '/indextable',
            component: indextable,
            meta: {requireAuth: true},
            template: '<indextable>'
        },
        {
            path: '/login',
            // name: 'Login',
            component: login
        },
        {
            path: '/home',
            meta: {requireAuth: true},
            component: home,
            children: [

                {
                    path: '/',
                    component: index,
                    meta: {requireAuth: true},
                    template: '<index>'
                },
                {
                    path: '/home/creative',
                    component: creative,
                    meta: {requireAuth: true},
                    children: [
                        {
                            path: '/home/creative/iqiyi',
                            component: iQiYiad,
                            meta: {requireAuth: true},
                            template: '<iQiYiad>'
                        },
                        {
                            path: '/home/creative/commAdUser',
                            component: commAdUser,
                            meta: {requireAuth: true},
                            template: '<commAdUser>'
                        },
                        {
                            path: '/home/creative/iqiyiCreative',
                            component: iQiYiCreative,
                            meta: {requireAuth: true},
                            template: '<iQiYiCreative>'
                        },
                        {
                            path: '/home/creative/mgCreative',
                            component: mgCreative,
                            meta: {requireAuth: true},
                            template: '<mgCreative>'
                        },
                        {
                            path: '/home/creative/mgCreative2',
                            component: mgCreative2,
                            meta: {requireAuth: true},
                            template: '<mgCreative>'
                        },
                        {
                            path: '/home/creative/mgCreative3',
                            component: mgCreative3,
                            meta: {requireAuth: true},
                            template: '<mgCreative>'
                        },
                        {
                            path: '/home/creative/wangyi',
                            component: wyCreative,
                            meta: {requireAuth: true},
                            template: '<wyCreative>'
                        },
                        {
                            path: '/home/creative/wyAdd',
                            component: wyAddCreative,
                            meta: {requireAuth: true},
                            template: '<wyAddCreative>'
                        },
                        {
                            path: '/home/creative/wbAdvertisers',
                            component: wbAdvertisers,
                            meta: {requireAuth: true},
                            template: '<wbAdvertisers>'
                        },
                        {
                            path: '/home/creative/wbCreative',
                            component: wbCreative,
                            meta: {requireAuth: true},
                            template: '<wbCreative>'
                        },
                        {
                            path: '/home/creative/MeituCreative',
                            component: MeituCreative,
                            meta: {requireAuth: true},
                            template: '<MeituCreative>'
                        },
                        {
                            path: '/home/creative/idxAdvertiser',
                            component: idxAdvertiser,
                            meta: {requireAuth: true},
                            template: '<idxAdvertiser>'
                        },
                        {
                            path: '/home/creative/idxIdeas',
                            component: idxIdeas,
                            meta: {requireAuth: true},
                            template: '<idxIdeas>'
                        },
                        {
                            path: '/home/creative/msAdvertiser',
                            component: msAdvertiser,
                            meta: {requireAuth: true},
                            template: '<msAdvertiser>'
                        },
                        {
                            path: '/home/creative/msIdeas',
                            component: msIdeas,
                            meta: {requireAuth: true},
                            template: '<msIdeas>'
                        },
                        {
                            path: '/home/creative/bdIdeas',
                            component: bdIdeas,
                            meta: {requireAuth: true},
                            template: '<bdIdeas>'
                        },
                        {
                            path: '/home/creative/zhIdeas',
                            component: zhIdeas,
                            meta: {requireAuth: true},
                            template: '<zhIdeas>'
                        },
                        {
                            path: '/home/creative/ottUpload',
                            component: ottUpload,
                            meta: {requireAuth: true},
                            template: '<ottUpload>'
                        },
                        {
                            path: '/home/creative/tcIdeas',
                            component: tcIdeas,
                            meta: {requireAuth: true},
                            template: '<tcIdeas>'
                        },
                        {
                            path: '/home/creative/sohuAdvertisers',
                            component: sohuAdvertisers,
                            meta: {requireAuth: true},
                            template: '<sohuAdvertisers>'
                        },
                        {
                            path: '/home/creative/sohuCreative',
                            component: sohuCreative,
                            meta: {requireAuth: true},
                            template: '<sohuCreative>'
                        },
                        {
                            path: '/home/creative/xiaomiCreative',
                            component: xiaomiCreative,
                            meta: {requireAuth: true},
                            template: '<xiaomiCreative>'
                        },
                        {
                            path: '/home/creative/tencentAdvertiser',
                            component: tencentAdvertiser,
                            meta: {requireAuth: true},
                            template: '<tencentAdvertiser>'
                        },
                        {
                            path: '/home/creative/tencentQualification',
                            component: tencentQualification,
                            meta: {requireAuth: true},
                            template: '<tencentQualification>'
                        },
                        {
                            path: '/home/creative/tencentIdeas',
                            component: tencentIdeas,
                            meta: {requireAuth: true},
                            template: '<tencentIdeas>'
                        },
                        {
                            path: '/home/creative/zfbIdeas',
                            component: zfbIdeas,
                            meta: {requireAuth: true},
                            template: '<zfbIdeas>'
                        },
                        {
                            path: '/home/creative/youkuCreative',
                            component: YouKuCreative,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/youKuAdvertiser',
                            component: YouKuAdvertiser,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/youKuCreativeAdd',
                            component: YouKuCreativeAdd,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/VIOOHIdeas',
                            component: VIOOHIdeas,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/leboCreative',
                            component: leboCreative,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/miguCreative',
                            component: miguCreative,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/haizhiCreative',
                            component: HaizhiCreative,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/oppoCreative',
                            component: oppoCreative,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/bilibiliCreative',
                            component: bilibiliCreative,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/yinheCreative',
                            component: yinheCreative,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/sohuNewsAdvertiser',
                            component: sohuNewsAdvertiser,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/creative/sohuNewsCreative',
                            component: sohuNewsCreative,
                            meta: {requireAuth: true}
                        }
                    ]
                },
                {
                    path: '/home/delivery',
                    component: delivery,
                    meta: {requireAuth: true},
                    children: [
                        {
                            path: '',
                            redirect: '/home/delivery/project'
                        },
                        {
                            path: '/home/delivery/project',
                            component: deliveryProject,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/delivery/project/add',
                            component: deliveryProjectAdd,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/delivery/project/edit/:id',
                            component: deliveryProjectAdd,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/delivery/project/analysis',
                            component: deliveryProjectAnalysis,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/delivery/plan',
                            component: deliveryPlan,
                            meta: {requireAuth: true}
                        },
                        {
                            path: '/home/delivery/projectData',
                            component: reportProject,
                            meta: {requireAuth: true}
                        }
                    ]
                },
                {
                    path: '/home/report',
                    component: report,
                    meta: {requireAuth: true},
                    children: [
                        {
                            path: '/',
                            redirect: '/home/report/ssp'
                        },
                        {
                            path: '/home/report/ssp',
                            component: sspreport2,
                            meta: {requireAuth: true},
                            template: '<sspreport2>'
                        },
                        {
                            path: '/home/report/slot',
                            component: sspslot,
                            meta: {requireAuth: true},
                            template: '<sspslot>'
                        },
                        {
                            path: '/home/report/realtime',
                            component: realtime,
                            meta: {requireAuth: true},
                            template: '<realtime>'
                        },
                        {
                            path: '/home/report/dealrealtime',
                            component: dealrealtime,
                            meta: {requireAuth: true},
                            template: '<dealrealtime>'
                        }
                    ]
                },
                {
                    path: '/home/setting',
                    component: setting,
                    meta: {requireAuth: true},
                    children: [
                        {
                            path: '',
                            redirect: '/home/setting/commonsetting'
                        },
                        {
                            path: '/home/setting/commonsetting',
                            component: commonsetting,
                            meta: {requireAuth: true},
                            template: '<commonsetting>'
                        },
                        {
                            path: '/home/setting/mediaStrategy',
                            component: mediaStrategy,
                            meta: {requireAuth: true},
                            template: '<mediaStrategy>'
                        },
                        {
                            path: '/home/setting/dspStrategy/reachmax',
                            component: dspStrategy,
                            meta: {requireAuth: true},
                            template: '<dspStrategy>'
                        },
                        {
                            path: '/home/setting/dspStrategy/ttd',
                            component: dspStrategy,
                            meta: {requireAuth: true},
                            template: '<dspStrategy>'
                        },
                        {
                            path: '/home/setting/dspStrategy/nequal',
                            component: dspStrategy,
                            meta: {requireAuth: true},
                            template: '<dspStrategy>'
                        },
                        {
                            path: '/home/setting/dspStrategy/unionpay',
                            component: dspStrategy,
                            meta: {requireAuth: true},
                            template: '<dspStrategy>'
                        },
                        {
                            path: '/home/setting/dspStrategy/merkury',
                            component: dspStrategy,
                            meta: {requireAuth: true},
                            template: '<dspStrategy>'
                        },
                        {
                            path: '/home/setting/dspStrategy/detail',
                            component: dspStrategyDetail,
                            meta: {requireAuth: true},
                            template: '<dspStrategyDetail>'
                        },
                        {
                            path: '/home/setting/dspStrategy/dealDesk',
                            component: dspDealDesk,
                            meta: {requireAuth: true},
                            template: '<dspDealDesk>'
                        },
                        {
                            path: '/home/setting/dspStrategy/dealDesk/create',
                            component: dspDealCreate,
                            meta: {requireAuth: true},
                            template: '<dspDealCreate>'
                        },
                        {
                            path: '/home/setting/dspStrategy/dealDesk/edit',
                            component: dspDealEdit,
                            meta: {requireAuth: true},
                            template: '<dspDealEdit>'
                        },
                        {
                            path: '/home/setting/dealMapping',
                            component: dealMapping,
                            meta: {requireAuth: true},
                            template: '<dealMapping>'
                        },
                        {
                            path: '/home/setting/flowSetting',
                            component: flowSetting,
                            meta: {requireAuth: true},
                            template: '<flowSetting>'
                        },
                        {
                            path: '/home/setting/addFlow',
                            component: addFlow,
                            meta: {requireAuth: true},
                            template: '<addFlow>'
                        },
                        {
                            path: '/home/adxSetting',
                            component: adxSetting,
                            meta: {requireAuth: true},
                            template: '<adxSetting>'
                        }

                    ]
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js